import React, { useState, useEffect } from "react"
import theme from "theme"
import { Theme, Box, Section, Text } from "@quarkly/widgets"

import { GlobalQuarklyPageStyles } from "global-page-styles"
import { Override } from "@quarkly/components"
import * as Components from "components"
import translations from "../translations"

const PagePrivacyPolicy = () => {
  const [lang, setLang] = useState("en")

  useEffect(() => {
    const savedLang = localStorage.getItem("lang")
    if (savedLang) {
      setLang(savedLang)
    }
    const syncLang = () => {
      const savedLang = localStorage.getItem("lang")
      if (savedLang) {
        setLang(savedLang)
      }
    }
    window.addEventListener("languagechange", syncLang)
    return () => window.removeEventListener("languagechange", syncLang)
  }, [])

  const t = translations[lang]

  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"privacy-policy"} />
      <Components.SEO
        title={t.privacyPolicy.seoTitle}
        pathname="/privacy-policy"
      />
      <Components.Header lang={lang} />
      <Section
        padding="0"
        quarkly-title="HeroBlock"
        background="linear-gradient(0deg,rgba(255,255,255,0.4) 0%,rgba(255,255,255,0.6) 100%),rgba(0, 0, 0, 0) url(/images/home_hero.png) center/cover repeat scroll padding-box"
        display="flex"
        flex-direction="column"
      >
        <Override
          slot="SectionContent"
          max-width="none"
          width="100%"
          padding="0"
        />
        <Box
          padding="200px 60px 100px 60px"
          sm-padding="160px 20px 80px 20px"
          display="flex"
          flex-direction="column"
          max-width="900px"
          align-items="center"
          margin="0 auto"
        >
          <Text
            color="--dark"
            font="normal 600 64px/1.1 --fontFamily-googlePoppins"
            margin="0 0 32px 0"
            sm-font="normal 600 32px/1.15 --fontFamily-googlePoppins"
            lg-font="normal 600 48px/1.1 --fontFamily-googlePoppins"
            text-align="center"
          >
            {t.privacyPolicy.title}
          </Text>
          <Box width="40px" height="2px" background="--color-dark" margin="0" />
        </Box>
      </Section>
      <Section
        padding="40px 60px 140px 60px"
        background="--color-light"
        sm-padding="20px 20px 80px 20px"
      >
        <Override
          slot="SectionContent"
          max-width="1000px"
          margin="0 auto"
          color="--darkL2"
          font="normal 300 16px/1.8 --fontFamily-googleInter"
        />
        <Box width="100%" className="legal-document">
          <Components.PrivacyPolicy lang={lang} />
        </Box>
      </Section>
      <Components.Footer lang={lang} />

      <Components.ScrollToTop />
      <Components.CookieBanner />
    </Theme>
  )
}
export default PagePrivacyPolicy
